module.exports = __webpack_public_path__ + "static/media/forms.e9ad57cc.svg";